module.exports = __webpack_public_path__ + "img/parts.05df41b7.png";